import * as z from "zod";

export const resyncOpenReturnsBillToCadence = {
  name: "resyncOpenReturnsBillToCadence" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ restamped: z.boolean() }),
};
